import React from 'react';
import { TextareaAutosize, styled } from '@mui/material';
import { SetValueETargetValue } from "../../Services/service";

const StyledTextArea = styled(TextareaAutosize, {
  shouldForwardProp: (props) => props !== "focusColor",
})((p) => ({
  width: '100%',
  padding: '8px 12px',
  fontFamily: 'Roboto, sans-serif',
  fontSize: '14px',
  lineHeight: 1.5,
  borderRadius: '4px',
  border: `1px solid ${p.theme.palette.grey[500]}`,
  backgroundColor: 'white',
  resize: 'vertical',
  height: 'auto',
  
  '&:focus': {
    outline: 'none',
    borderColor: p.focusColor || '#c4960c',
    boxShadow: `0 0 0 1px ${p.focusColor || '#c4960c'}`,
  },
  
  '&:disabled': {
    color: 'black',
    backgroundColor: '#E9E9E5',
    borderColor: 'black',
    WebkitTextFillColor: 'black',
    cursor: 'not-allowed',
  },
  minHeight: '34px',
  "@media (max-width: 2200px) and (min-width: 2000px)": {
    fontSize: "22px",
  },
  "@media (max-width: 2000px) and (min-width: 1800px)": {
    fontSize: "17px",
  },
  
  "@media (max-width: 1800px) and (min-width: 1400px)": {
    fontSize: "15px",
  },
  '@media (max-width: 960px) and (min-width: 769px)': {
    fontSize: '12px',
  },
  "@media (max-width: 768px) and (min-width: 687px)": {
    fontSize: "20px",
    minHeight: '50px',
  },
  "@media (max-width: 687px)": {
    fontSize: "12px",
    height: "8px"
  },
  
}));

export const Cus_TFArea = ({
  id,
  placeholder,
  name,
  value,
  setValue,
  sx,
  hidden,
  focusColor = '#c4960c',
  minRows = 3,
  maxRows,
  disabled,
}) => {
  return (
    <StyledTextArea className="tf-normal" id={id} placeholder={placeholder} name={name} value={value}
      onChange={(e) => SetValueETargetValue(e.target.value, setValue)} focusColor={focusColor}
      minRows={minRows} maxRows={maxRows} disabled={disabled} hidden={hidden} autoComplete="off"
      sx={{
        backgroundColor: 'white',
        marginTop: '5px',
        marginBottom: '5px',
        ...sx,
      }}
    />
  );
};